import React from 'react';
import { Box, Button, Checkbox, Typography } from '@mui/material';
import useStudents from './students-hook';
import List from './List';
import StateFilter from '../../../components/StateFilter';
import DistrictFilter from '../../../components/DistrictFilter';
import SchoolFilter from '../../../components/SchoolFilter';
import ClassFilter from '../../../components/ClassFilter';
import useRole from '../../../hooks/useRole';
import { Link } from 'react-router-dom';
import { SectionCategory } from '../../../generated/graphql';

const Students = () => {
  const {
    students,
    pagination,
    loading,
    totalCount,
    sort,
    order,
    isTableEmpty,
    handlePageChange,
    handleSort,
    selectedState,
    onStateChange,
    selectedDistrict,
    onDistrictChange,
    selectedClass,
    onClassChange,
    selectedSchool,
    onSchoolChange,
    districtPermission,
    schoolPermission,
    rowsPerPage,
    setRowsPerPage,
    isSourceId, setIsSourceId,
  } = useStudents();
  const { isSuperAdmin } = useRole();
  return (
    <Box
      display="flex"
      flexDirection="column"
      width="100%"
    >
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
      >
        <Box>
          <Typography variant="pageTitle">
            Students
          </Typography>
        </Box>
        <Box>
          {isSuperAdmin  && (
            <Button
              variant="outlined"
              color="primary"
              disableRipple={true}
              component={Link}
              to="/admin/create/student"
            >
            Add Student
            </Button>
          )}
        </Box>
      </Box>
      <Box
        display="grid"
        gridTemplateColumns={`repeat(${districtPermission ? 4 : (schoolPermission ? 2 : 1)}, 15%) 1fr 200px`}
        sx={{
          gridGap: 24,
        }}
        mt={2}
      >
        {districtPermission && (
          <>
            <StateFilter
              value={selectedState}
              onChange={onStateChange}
              idSelectOnly
              placeholder="All states"
            />
            <DistrictFilter
              value={selectedDistrict}
              onChange={onDistrictChange}
              stateIds={selectedState ?? undefined}
              idSelectOnly
              placeholder="All districts"
            />
          </>
        )}
        {schoolPermission
        && (
          <SchoolFilter
            value={selectedSchool}
            onChange={onSchoolChange}
            stateId={selectedState ?? undefined}
            districtId={selectedDistrict ?? undefined}
            idSelectOnly
            placeholder="All schools"
          />
        )}
        <ClassFilter
          value={selectedClass}
          onChange={onClassChange}
          stateId={selectedState ?? undefined}
          districtId={selectedDistrict ?? undefined}
          schoolId={selectedSchool ?? undefined}
          idSelectOnly
          placeholder="All classes"
          classTypes={[SectionCategory.Class, SectionCategory.CustomClass]}
        />
        <Box>
          <Checkbox
            name="show_source_id"
            checked={isSourceId}
            onChange={(e) => setIsSourceId(e.target.checked)}
            color="primary"
            inputProps={{ 'aria-label': 'primary checkbox' }}
          />
          <Typography variant='sFormHelperText'>
            Show Source ID
          </Typography>
        </Box>
        <Box />
      </Box>
      <Box>
        <List
          isTableEmpty={isTableEmpty}
          loading={loading}
          totalCount={totalCount}
          order={order}
          pagination={pagination}
          sort={sort}
          students={students}
          handlePageChange={handlePageChange}
          handleSort={handleSort}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
          isSourceId={isSourceId}
        />
      </Box>
    </Box>
  );
};

export default React.memo(Students);
